"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceFormat = PriceFormat;

var _currencyHelper = require("@eig-builder/core-utils/helpers/currency-helper");

function PriceFormat(params) {
  var currencySymbol = params.colDef.currencySymbol;

  if (!currencySymbol) {
    currencySymbol = params.data[params.colDef.currencySymbolField];
  }

  var currencyObj = {
    code: currencySymbol
  };
  return (0, _currencyHelper.formatCurrency)(params.value, currencyObj);
}